import React from "react";
import '../index.css';

function Contact(){
    return(
        <>
        <div className="heroic">
            <h1>LET'S WORK <span>TOGETHER</span></h1>
        </div>
        </>
    );
}

export default Contact;